//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Adm.WebControls.SeznamSpisovePlanyDesigner.ts        </Name>
//    <Description>                                                             </Description>
//    <Author>      THAZMUKA                                                    </Author>
//    <Copyright>   © GORDIC spol. s r. o. 1993-2019                            </Copyright>
//    <Created>     2019-10-30                                                  </Created>
//  </FileHeader>

// tento script bude strojně generován podle XML předpisu definujícího SEZNAM

/// <reference path="../../Base/SeznamBase.ts" />

namespace Gordic.Adm.WebControls {

    /**
     * Designer seznamu spisových plánů
     * 
     * @author thazmuka
     * @since 482.1.0.73
     */
    export class SeznamSpisovePlanyDesigner extends SeznamBase {

        /** isl view gridu seznamu spisových plánů */
        view: Gordic.Isl.View<any>;

        static SeznamSpisovePlanyDesignerInit(that: GContentType<SeznamSpisovePlanyDesigner>) {

            that.gridSearchColumns = [""]; // "ixs_grf, dat_od, dat_do".split(",");

            SeznamBase.SeznamBaseInit(that as GContentType<SeznamBase>);

            //that.filter = this.createFilter(that);

            that.gridFormat = this.createGridFormat(that);

            //that.view = new Gordic.Isl.View(that.isl.GrafObsah.list(), { filterPanel: that.filter, startEmpty: false, });       // propojení ovládacího prvku gridu se zdrojem dat - a s filter panelem

        } // SeznamGrafObsahDesignerInit

        /** vytvořit formát seznamu - definice sloupců, napdpisů, šířek atd... */
        static createGridFormat(that: GContentType<SeznamSpisovePlanyDesigner>): Gordic.Data.GridFormat {

            var columnsDefinition = this.createGridFormatBase(that);

            //columnsDefinition
            //    .addDateTimeColumn({
            //        name: "dat_od",
            //        caption: "jres:32131055", //RC 32131055 : Datum OD
            //        width: 150,
            //        fragment: ""
            //    })
            //    .addDateTimeColumn({
            //        name: "dat_do",
            //        caption: "jres:32131056", //RC 32131056 : Datum DO
            //        width: 150,
            //        fragment: ""
            //    })
            //    .addNumberColumn({
            //        name: "grf_count",
            //        caption: "jres:32131094", //RC 32131094 : Počet
            //        width: 150,
            //        fragment: "seznam"
            //    })
            //    .addNumberColumn({
            //        name: "grf_sum",
            //        caption: "jres:32131095", //RC 32131095 : Součet
            //        width: 150,
            //        fragment: "seznam"
            //    })

            return columnsDefinition;
        } // createGridFormat

    }
}